/**
 * Behavior for event sign up button
 *
 * Sign up button is a link to webform that we want to duplicate in event details
 */
/*Drupal.behaviors.rmccSignUp = {
  attach(context, settings) {
    once('rmccGallerySLiceBehavior', '.node--type-event .field--name-webform', context).forEach((elem) => {

      $('.event-details').addClass('with-sign-up');
      $('> div', '.event-details').append('<div class="layout__container-3" />');
      $('.layout__container-3', '.event-details').html($(elem).html());

    });
  }
};*/

(function (Drupal, $, once) {
  Drupal.behaviors.rmccEventForm = {
    attach(context, settings) {
      once('rmccEventForm', '.node--type-event', context).forEach((elem) => {

        let $button = $('.event--button', $(elem)),
            $panel  = $('.webform--wrapper', $(elem));

        $button.attr( 'tabIndex', 0 );

        if (!$('.no--panel').length) {
          // On click event.
          $button.click(function (e) {
            e.preventDefault();

          $panel.slideDown(300).addClass('hidden');
          $('#button--wrapper-2').fadeOut(300);

            $('html, body').delay(300).animate({
              scrollTop: $panel.position().top
            }, 200);
          });

          // On press of enter key event.
          $button.keyup(function (e) {
            e.preventDefault();

            if (e.keyCode == 13) {
              $panel.slideDown(300);
              $('#button--wrapper-2').fadeOut(300);

              $('html, body').delay(300).animate({
                scrollTop: $panel.position().top
              }, 200);
            }
          });

        }

      });
    }
  };
}) (Drupal, jQuery, once);